// This is just a placeholder file for the 'Read' theme.
// View source the files in the `source/templates` directory for the actual templates used in the Read theme.

module.exports = (
	{
		TemplatePrefix: 'PictProvider-Theme-Read',
		Templates: [],
	}
);
